import { COLOR_PALETTE } from 'constants/ui';

export const containerStyles = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
};

export const searchContainerStyles = {
  padding: '12px 16px',
  borderBottom: ({ palette }) => `1px solid ${palette.border.default}`,
  flexShrink: 0,
};

export const searchInputStyles = {
  '& .MuiOutlinedInput-root': {
    height: 36,
    fontSize: 14,
    borderRadius: '8px',
  },
};

export const leadsListStyles = {
  flex: 1,
  overflow: 'auto',
};

export const leadItemStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  padding: '12px 16px',
  cursor: 'pointer',
  height: '100%',
  overflow: 'hidden',
  boxSizing: 'border-box',
  '&:hover': {
    backgroundColor: ({ palette }) => palette.background.secondary,
  },
};

export const leadAvatarStyles = {
  width: 40,
  height: 40,
  backgroundColor: COLOR_PALETTE.BRAND[5],
  fontSize: 14,
  fontWeight: 600,
  flexShrink: 0,
};

export const leadInfoStyles = {
  flex: 1,
  minWidth: 0,
};

export const leadNameStyles = {
  fontWeight: 600,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

export const leadPreviewStyles = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  color: ({ palette }) => palette.text.placeholder,
};

export const leadTimestampStyles = {
  color: ({ palette }) => palette.text.disabled,
  flexShrink: 0,
  whiteSpace: 'nowrap',
};

export const conversationContainerStyles = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
};

export const conversationHeaderStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  padding: '8px 12px',
  borderBottom: ({ palette }) => `1px solid ${palette.border.default}`,
  flexShrink: 0,
};

export const conversationHeaderNameStyles = {
  fontWeight: 600,
  flex: 1,
};

export const messagesListStyles = {
  flex: 1,
  overflow: 'auto',
  padding: '12px 16px',
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
};

const messageBubbleStyles = {
  maxWidth: '75%',
  padding: '8px 12px',
  borderRadius: '12px',
  wordBreak: 'break-word',
};

export const outgoingBubbleStyles = {
  ...messageBubbleStyles,
  alignSelf: 'flex-end',
  backgroundColor: COLOR_PALETTE.BRAND[5],
  color: '#ffffff',
};

export const incomingBubbleStyles = {
  ...messageBubbleStyles,
  alignSelf: 'flex-start',
  backgroundColor: ({ palette }) => palette.background.disabled,
};

export const messageAlignRightStyles = {
  textAlign: 'right',
};

export const messageAlignLeftStyles = {
  textAlign: 'left',
};

export const messageTimestampStyles = {
  fontSize: 10,
  color: ({ palette }) => palette.text.disabled,
  marginTop: '2px',
};

export const inputContainerStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  padding: '8px 12px',
  borderTop: ({ palette }) => `1px solid ${palette.border.default}`,
  flexShrink: 0,
};

export const textFieldStyles = {
  flex: 1,
  '& .MuiOutlinedInput-root': {
    fontSize: 14,
    borderRadius: '8px',
  },
};

export const emptyStateStyles = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '8px',
  color: ({ palette }) => palette.text.disabled,
};

export const loadingContainerStyles = {
  flex: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};
